import React from 'react';
import PropTypes from 'prop-types';

import keygen from '~helpers/keygen';
import Tabs from '~hooks/tabs';
import List from '~organisms/toplist/list';
import Grid from './grid';
import styles from './toplist.module.scss';

const TopList = ({ module, toplistHeading, page, modulePosition, showGrid = false }) => {
  const showTabs = module.items.length > 1;
  const content = module.items.map((toplist) => (
    <div
      className={!showTabs && (styles.toplistContainer || '')}
      label={toplist.title}
      key={keygen()}
    >
      {toplistHeading}
      {showGrid ? (
        <Grid
          pagePath={page?.path}
          toplist={toplist}
          hasLoadMoreButton={toplist.show_load_more}
          initItemsCount={toplist.num_items_initial_load || 0}
          loadItemsCount={toplist.num_items_load_more}
          pageTemplate={page?.template}
          module={module.name}
          extraFields={page?.extraFields}
          modulePosition={modulePosition}
        />
      ) : (
        <List
          pagePath={page?.path}
          toplist={toplist}
          hasLoadMoreButton={toplist.show_load_more}
          initItemsCount={toplist.num_items_initial_load || 0}
          loadItemsCount={toplist.num_items_load_more}
          pageTemplate={page?.template}
          module={module}
          extraFields={page?.extraFields}
          modulePosition={modulePosition}
        />
      )}
    </div>
  ));

  return showTabs ? (
    // eslint-disable-next-line react/no-children-prop
    <Tabs tabsAlign="right" gtmClass="toplist-tabs-menu-gtm" children={content} />
  ) : (
    content
  );
};

TopList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  module: PropTypes.shape({
    name: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object),
    style: PropTypes.string,
  }),
  toplistHeading: PropTypes.element,
  page: PropTypes.shape({
    template: PropTypes.string,
    path: PropTypes.string,
    extraFields: PropTypes.shape({}),
  }),
  modulePosition: PropTypes.number,
  showGrid: PropTypes.bool,
};

export default TopList;
